import { makeActionCreator } from '@/utils';
import { type Navigate } from './types';

const createAction = makeActionCreator('app');

export const navigate = createAction<Navigate>('navigate');
